import React from "react";
import Profile from "../components/mypage/Profile";

function Mypage() {
  return <Profile />;
}

export default Mypage;
